import React from "react";
import MediaQuery from "react-responsive";
import PropTypes from "prop-types";
export default class TabletOnly extends React.Component {
  render() {
    return (
      <MediaQuery minWidth={768} maxWidth={991}>
        {this.props.children}
      </MediaQuery>
    );
  }
}

TabletOnly.propTypes = { children: PropTypes.element.isRequired };
